export default {
    title: '씨앗글자',
    intro: `씨앗글자는 '글자'와 '그 글자가 쓰인 단어'를 살펴봄으로 단어가 <br>어떻게 만들어지는지 그 원리와 과정을 배울 수 있어요. 씨앗글자 <br>훈련을 통해 모르는 단어의 의미를 쉽게 유추할 수 있어요.`,
    quizIntro: '그동안 배운 글자들을 떠올리며 문제를 풀어 보세요.',
    header: {
        navigator: '{level}레벨 {round}번째',
    },
    subject: {
        letter: '씨앗글자 익히기',
        relation: '의미 관계 확인하기',
        board: '내가 배운 씨앗글자',
        lesson: '씨앗글자 훈련',
        quiz: '씨앗글자 쪽지시험',
    },
    indicator: {
        letter: '글자를 클릭하면서 씨앗글자의 모양, 소리, 뜻을 배워요.',
        word: '단어를 클릭하며 씨앗글자가 단어에서 어떻게 쓰이는지 배워요.',
        words: '씨앗글자가 들어간 두 단어를 배워요.',
        choose1: '아래의 두 단어에는 공통으로 들어가는 글자가 있어요. <br/>',
        choose2: "두 단어 중 'word' 자가 사용된 단어는 무엇일까요?",
        relation: '두 씨앗글자의 의미 관계는 무엇일까요?',
        quiz: '빈칸에 들어갈 글자로 알맞은 것은 무엇일까요?',
    },
    study: {
        example: '예문',
        meaning: '뜻',
        sound: '소리',
        listen: '소리 듣기',
    },
    modal: {
        notCompleted: '이전 회차의 모든 학습을 완료한 뒤에 학습할 수 있습니다.',
        moveToWaiting: '대기실로 이동하시겠습니까?',
        invalidAccess: '잘못된 접근입니다.',
    },
    exitModal: {
        title: '훈련이 끝나지 않았어요!',
        message: '지금 멈추면 훈련 내용이 저장되지 않을 수 있어요!',
        continue: '계속하기',
        stop: '중단하기',
    },
    result: {
        totalQuestionMessage: 'total문제 중에 score문제를 맞혔어요.',
        checkMessage: '모든 정답을 꼼꼼히 확인해보세요.',
        correct: '정답',
        selected: '선택',
        incorrect: '오답',
    },
    button: {
        nextWord: '다음 학습하기',
        nextLevel: '다음 레벨가기',
        start: '시작하기',
        finishStudy: '학습 끝내기',
        finishExam: '시험 끝내기',
        confirm: '확인',
    },
    relation: {
        synonym: {
            name: '유의',
            description: '두 글자의 모양이 다르지만<br />  뜻은 비슷해요',
        },
        opposite: {
            name: '반의',
            description: '두 글자의 뜻이<br /> 서로 반대돼요',
        },
        hierarchy: {
            name: '상하',
            description: '한 글자의 뜻이<br /> 다른 글자의 뜻을 포함해요',
        },
        same: {
            name: '동음',
            description: '두 글자가 소리는 같지만<br /> 뜻이 달라요',
        },
        different: {
            name: '다의',
            description: '한 글자에<br /> 여러 개의 뜻이 있어요',
        },
    },
};
